const theme = {
  section: {
    width: '100vw',
    marginLeft: 'calc(50% - 50vw)',
  },
  container: {
    maxWidth: '1100px',
    padding: '20px',
    margin: '0 auto',
    backgroundColor: '#fff',
  },
  title: {
    textAlign: 'center',
    marginBottom: '30px'
  },
  list: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  contentMasonry: {
   maxWidth: '1200px',
   margin: '0 auto',
 },
  listItem: {

  },
};

export default theme;
